import React from 'react';
import ListingImageGallery from './ListingImageGallery/ListingImageGallery';

import css from './ListingPage.module.css';

const SectionGallery = props => {
  const { listing, variantPrefix, publicData, onManageDisableScrolling } = props;
  const images = listing.images;
  const imageVariants = ['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge'];
  const thumbnailVariants = [variantPrefix, `${variantPrefix}-2x`, `${variantPrefix}-4x`];

  const secondaryImagesIds = publicData?.secondaryImagesIds;
  const primaryImages = images?.filter(img => !secondaryImagesIds?.includes(img.id.uuid));

  return (
    <section className={css.productGallery} data-testid="carousel">
      <ListingImageGallery
        images={primaryImages}
        imageVariants={imageVariants}
        thumbnailVariants={thumbnailVariants}
        onManageDisableScrolling={onManageDisableScrolling}
        listingTitle={listing?.attributes?.title}
      />
    </section>
  );
};

export default SectionGallery;
